// Strings for the settings console shell (src/pages/settings/).
// Panel-specific strings live with their feature (e.g. smartRouting.js).
export default {
  en: {
    title: "Settings",
    call_settings: "Call Settings",
    sections: {
      routing: "Queues & Routing",
      call_handling: "Call Handling",
      performance: "Performance",
      workforce: "Workforce",
    },
  },
  ar: {
    title: "الإعدادات",
    call_settings: "إعدادات المكالمات",
    sections: {
      routing: "المجموعات والتوجيه",
      call_handling: "معالجة المكالمات",
      performance: "الأداء",
      workforce: "الموظفون",
    },
  },
};
